import axios from "axios";
import * as ActionType from "./coinPackage.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getCoinPackage = () => (dispatch) => {
  apiInstanceFetch
    .get(`coinPackage/getAllPackages`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_COIN_PACKAGE,
        payload: res.packages,
      });
    })
    .catch((error) => console.error(error));
};

export const createCoinPackage = (formData) => (dispatch) => {
  axios
    .post(`coinPackage/create`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_COIN_PACKAGE,
          payload: res.data.package,
        });
        setToast("success", "Coin package created successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to create coin package");
    });
};

export const updateCoinPackage = (formData, id) => (dispatch) => {
  axios
    .patch(`coinPackage/update?packageId=${id}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_COIN_PACKAGE,
          payload: { data: res.data.package, id },
        });
        setToast("success", "Coin package updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to update coin package");
    });
};

export const deleteCoinPackage = (id) => (dispatch) => {
  axios
    .delete(`coinPackage/delete?packageId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_COIN_PACKAGE,
          payload: id,
        });
        setToast("success", "Coin package deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to delete coin package");
    });
};
